"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SampleEventFactoryInterface = _interopRequireDefault(require("crm_ui/utils/sampleData/SampleEventFactoryInterface"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var makeCallLogSampleTimelineEvent = (0, _SampleEventFactoryInterface.default)({
  requiredData: {
    eventType: _TimelineConstants.EVENT_ENGAGEMENT,
    itemType: _EngagementTypes.CALL
  },
  eventDefaults: {
    durationMilliseconds: 0,
    body: ''
  },
  build: function build(callData) {
    var durationMilliseconds = callData.durationMilliseconds,
        body = callData.body;
    var eventData = {
      metadata: {
        body: body,
        durationMilliseconds: durationMilliseconds,
        externalId: null,
        fromNumber: null,
        recordingUrl: null,
        status: null,
        toNumber: null
      }
    };
    return eventData;
  }
});
var _default = makeCallLogSampleTimelineEvent;
exports.default = _default;
module.exports = exports.default;